import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postInvoiceStatus } from 'api/resources/invoices';
import { ECacheKeys } from 'cache/CacheKeys';

export const usePostInvoicesStatus = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: postInvoiceStatus,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [ECacheKeys.Overviews],
			});
		},
	});
};
